import React, { useState } from 'react';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';

const RecipientForm = ({ onSubmit, onBack, selectedName }) => {
  const [phone, setPhone] = useState('');
  const [error, setError] = useState('');

  const validatePhone = (value) => {
    const phoneRegex = /^09\d{9}$/;
    return phoneRegex?.test(value);
  };

  const handleSubmit = (e) => {
    e?.preventDefault();

    if (!validatePhone(phone)) {
      setError('شماره موبایل باید با 09 شروع شده و 11 رقم باشد');
      return;
    }

    setError('');
    onSubmit(phone);
  };

  const handlePhoneChange = (e) => {
    const value = e?.target?.value?.replace(/[^0-9]/g, '');
    setPhone(value);
    if (error) setError('');
  };

  return (
    <div className="bg-white rounded-2xl shadow-xl p-8">
      <div className="text-center mb-8">
        <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-r from-purple-500 to-pink-500 rounded-full mb-4">
          <span className="text-3xl">📱</span>
        </div>
        <h2 className="text-2xl font-bold text-gray-800 mb-2">شماره گیرنده</h2>
        <p className="text-gray-600">
          پیام برای{' '}
          <span className="font-bold text-purple-600">{selectedName}</span>{' '}
          ارسال می‌شود
        </p>
      </div>

      <form onSubmit={handleSubmit} className="space-y-6">
        <div>
          <label className="block text-sm font-semibold text-gray-700 mb-2">
            شماره موبایل گیرنده
          </label>
          <input
            type="tel"
            value={phone}
            onChange={handlePhoneChange}
            placeholder="09123456789"
            maxLength={11}
            className="w-full px-4 py-3 border-2 rounded-xl focus:outline-none text-center text-lg tracking-wider border-purple-200 focus:border-purple-500"
            dir="ltr"
          />
          {error && (
            <p className="mt-2 text-sm text-red-600 flex items-center gap-2">
              <span>⚠️</span>
              {error}
            </p>
          )}
          <p className="mt-2 text-xs text-gray-500">
            پیام به صورت کاملاً ناشناس ارسال می‌شود
          </p>
        </div>

        <div className="bg-gradient-to-r from-purple-50 to-pink-50 border-2 border-purple-200 rounded-xl p-4">
          <div className="flex items-start gap-3">
            <span className="text-2xl">🔒</span>
            <div className="text-sm text-gray-700">
              <p className="font-semibold mb-1">حریم خصوصی شما محفوظ است</p>
              <p className="text-xs">
                هویت شما هیچ‌گاه فاش نمی‌شود و پیام به صورت کاملاً ناشناس ارسال
                می‌گردد.
              </p>
            </div>
          </div>
        </div>

        <div className="flex gap-4">
          <Button
            type="button"
            onClick={onBack}
            variant="outline"
            className="flex-1"
          >
            بازگشت
          </Button>
          <Button
            type="submit"
            className="flex-1 bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700"
          >
            ادامه
          </Button>
        </div>
      </form>
    </div>
  );
};

export default RecipientForm;
